export default {
  getFreshChatUserData: '/service/cs/v1/fresh-chat/user-data/get',
  getSenderAuth: '/user/sender.json',
  getWebimInfo: '/accounting/api/webim_hash',
  updateFreshChatUserData: '/service/cs/v1/fresh-chat/user-data/update',
  getZendeskChatUser: '/service/cs/v1/zendesk/user-data/get',
  getZendeskClassicChatUser: '/service/cs/v1/zendesk-classic/user-data/get'
};
